import React from 'react'
import { NavLink } from 'react-router-dom'
import { roles } from '../../common/config'

import './Header.scss'

const translateRole = (role) => {
  switch (role) {
    case roles.INSTRUCTOR: return 'Instruktor'
    case roles.PC_OPERATOR: return 'PC asist.'
    case roles.PSYCHOLOGIST: return 'Psycholog'
    case roles.FLEET_MANAGER: return 'CFM'
    case roles.ADMIN: return 'Organiz.'
    case roles.SUPERVISOR: return 'Supervizor'
    default: return ''
  }
}

const NavItem = ({ to, label, icon, exact = false }) => (
  <NavLink to={to} exact={exact} activeClassName="active">
    <i className={`daicon daicon-${icon}`} />
    <span>{label}</span>
  </NavLink>
)

NavItem.defaultProps = {
  exact: false,
}
NavItem.propTypes = {
  to: React.PropTypes.string.isRequired,
  label: React.PropTypes.string.isRequired,
  icon: React.PropTypes.string.isRequired,
  exact: React.PropTypes.bool,
}

const Header = ({ viewer, version }) => (
  <header className="header-component">
    <div className="logo">
      <NavLink exact to="/" activeClassName="active"><img src="/images/eda-white.svg" alt="logo" /></NavLink>
    </div>
    <NavItem to="/results" label="Hodnocení" icon="Test" />
    {([roles.ADMIN, roles.SUPERVISOR, roles.FLEET_MANAGER].indexOf(viewer.role) !== -1) &&
      <NavItem to="/drivers" label="Řidiči" icon="Driver" />
    }
    {([roles.ADMIN, roles.SUPERVISOR, roles.FLEET_MANAGER].indexOf(viewer.role) !== -1) &&
      <NavItem to="/attendances" label="Prezenční listiny" icon="SignUp" />
    }
    {([roles.ADMIN, roles.SUPERVISOR].indexOf(viewer.role) !== -1) &&
      <NavItem to="/companies" label="Dopravci" icon="Company" />
    }
    {([roles.ADMIN, roles.SUPERVISOR].indexOf(viewer.role) !== -1) &&
      <NavItem to="/locations" label="Lokace" icon="Map" />
    }
    {([roles.ADMIN, roles.SUPERVISOR].indexOf(viewer.role) !== -1) &&
      <NavItem to="/users" label="Uživatelé" icon="Group" />
    }
    <nav className="users-navigation">
      <NavItem to="/settings" label="Nastavení" icon="Settings" />
      {viewer && (
        <div className="viewer">{viewer.name} ({translateRole(viewer.role)})</div>
      )}
      {version && <div className="version">v{version}</div>}
    </nav>
  </header>
)

Header.defaultProps = {
  version: '',
}

Header.propTypes = {
  viewer: React.PropTypes.object.isRequired,
  signOut: React.PropTypes.func.isRequired,
  version: React.PropTypes.string,
}

export default Header



// WEBPACK FOOTER //
// ./src/browser/components/Header.js